import  { useState } from 'react';
import { Link } from 'react-router-dom';
import  { useAuth } from '../contexts/AuthContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isLoggedIn, user, logout } = useAuth();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <nav className="bg-primary text-white p-4 fixed w-full top-0 z-10 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          {/* Logo - Left */}
          <Link to="/" className="flex items-center">
  <svg
    width="200"
    height="44"
    viewBox="0 0 520 130"
    className="h-10 w-auto drop-shadow-sm hover:drop-shadow-lg transition-shadow duration-200"
    xmlns="http://www.w3.org/2000/svg"
  >
    
    <defs>
  {/* Steel gradient */}
  <linearGradient id="steel" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" stopColor="#94a3b8" />
    <stop offset="50%" stopColor="#e2e8f0" />
    <stop offset="100%" stopColor="#94a3b8" />
  </linearGradient>

  <linearGradient id="darkSteel" x1="0%" y1="0%" x2="0%" y2="100%">
    <stop offset="0%" stopColor="#475569" />
    <stop offset="100%" stopColor="#1e293b" />
  </linearGradient>

  <linearGradient id="purpleAccent" x1="0%" y1="0%" x2="100%" y2="100%">
    <stop offset="0%" stopColor="#8b5cf6" />
    <stop offset="100%" stopColor="#6d28d9" />
  </linearGradient>

  {/* Glow filter – FIXED flood props */}
  <filter id="glow">
    <feGaussianBlur stdDeviation="4" result="blurred"/>
    <feFlood floodColor="#8b5cf6" floodOpacity="0.6"/>
    <feComposite in2="blurred" operator="in"/>
    <feMerge>
      <feMergeNode/>
      <feMergeNode in="SourceGraphic"/>
    </feMerge>
  </filter>
</defs>

    {/* Vault Icon – scaled & positioned */}
    <g transform="translate(18,15) scale(0.26)">
      {/* Outer rim (super thick) */}
      <circle cx="150" cy="150" r="150" fill="none" stroke="#0f172a" strokeWidth="20"/>
      <circle cx="150" cy="150" r="142" fill="#1e293b"/>

      {/* Main vault door – brushed steel */}
      <circle cx="150" cy="150" r="138" fill="url(#steel)"/>

      {/* Classic vault spokes (8 big ones) */}
      {[0,45,90,135,180,225,270,315].map(angle => (
        <rect
          key={angle}
          x="145" y="10"
          width="10" height="280"
          fill="url(#darkSteel)"
          transform={`rotate(${angle} 150 150)`}
        />
      ))}

      {/* Giant wheel handle in the center */}
      <g filter="url(#glow)">
        <circle cx="150" cy="150" r="72" fill="#1e293b" stroke="url(#purpleAccent)" strokeWidth="10"/>
        <circle cx="150" cy="150" r="55" fill="#0f172a"/>

        {/* Handle grips */}
        {[0,90,180,270].map(a => (
          <rect key={a} x="140" y="90" width="20" height="60" rx="10"
            fill="#64748b" stroke="#1e293b" strokeWidth="4"
            transform={`rotate(${a} 150 150)`}
          />
        ))}

        {/* Purple center bolt */}
        <circle cx="150" cy="150" r="22" fill="url(#purpleAccent)"/>
        <circle cx="150" cy="150" r="14" fill="#7c3aed"/>
      </g>

      {/* Rivets around the edge */}
      {[0,30,60,90,120,150,180,210,240,270,300,330].map(a => {
        const rad = 122;
        const x = 150 + rad * Math.cos(a * Math.PI / 180);
        const y = 150 + rad * Math.sin(a * Math.PI / 180);
        return <circle key={a} cx={x} cy={y} r="10" fill="#334155" stroke="#0f172a" strokeWidth="3"/>;
      })}
    </g>

    {/* Text – kept bold and premium */}
    <text
  x="115"
  y="82"
  fontFamily="Exo 2, Rajdhani, system-ui, sans-serif"
  fontWeight="900"
  fontSize="56"
  fill="#e2e8f0"
  letterSpacing="2"
  style={{ textShadow: '0 2px 4px rgba(0,0,0,0.6)' }}
>
  SwiftVault
</text>
  </svg>
</Link>

          {/* Centered Links - Desktop */}
          <div className="hidden md:flex space-x-6 items-center mx-auto absolute left-1/2 transform -translate-x-1/2">
            {isLoggedIn ? (
              <>
                <Link to="/dashboard" className="hover:text-info transition-colors">Dashboard</Link>
                { user && user.role === 'admin' && (
                  <Link to="/admin" className="hover:text-info transition-colors">Admin</Link>
                )}
                <button onClick={logout} className="text-info hover:text-blue-500 transition-colors">Logout</button>
              </>
            ) : (
              <>
                <Link to="/" className="hover:text-info transition-colors">Home</Link>
                <Link to="/login" className="hover:text-info transition-colors">Login</Link>
                <Link to="/register" className="hover:text-info transition-colors">Register</Link>
                <Link
                  to="/register"
                  className="bg-primary text-white px-4 py-2 rounded-md hover:bg-blue-500 transition-colors"
                >
                  Get Started
                </Link>
              </>
            )}
          </div>

          {/* Mobile Menu Button - Right */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="focus:outline-none">
              <svg
                className={`w-6 h-6 transition-transform ${isOpen ? 'rotate-90' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Dropdown Menu */}
      <div
        className={`md:hidden fixed top-16 left-0 z-50 w-full bg-primary text-white transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100 visible' : 'max-h-0 opacity-0 invisible overflow-hidden'
        } backdrop-blur-sm`}
      >
        <div className="flex flex-col space-y-4 p-4">
          {isLoggedIn ? (
            <>
              <Link to="/dashboard" className="hover:text-info transition-colors py-2" onClick={closeMenu}>
                Dashboard
              </Link>
              { user && user.role === 'admin' && (
                <Link to="/admin" className="hover:text-info transition-colors py-2" onClick={closeMenu}>
                  Admin
                </Link>
              )}
              <button onClick={logout} className="text-info hover:text-blue-500 transition-colors py-2">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/" className="hover:text-info transition-colors py-2" onClick={closeMenu}>
                Home
              </Link>
              <Link to="/login" className="hover:text-info transition-colors py-2" onClick={closeMenu}>
            Login
          </Link>
          <Link to="/register" className="hover:text-info transition-colors py-2" onClick={closeMenu}>
            Register
          </Link>
          <Link
            to="/register"
            className="bg-primary text-white px-4 py-3 rounded-md text-center hover:bg-blue-500 transition-colors mt-2"
            onClick={closeMenu}
          >
            Get Started
          </Link>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Navbar;